import 'ol/ol.css';
import 'ol-ext/dist/ol-ext.min.css';

import Map from 'ol/Map';
import View from 'ol/View';
import proj from 'ol/proj';
import { transformExtent, transform } from 'ol/proj';
import { buffer } from 'ol/extent';

import BorderMask from './ol-geodok/filter/BorderMask';
import Mask from "ol-ext/filter/Mask";
import Fill from 'ol/style/Fill';
import WKT from 'ol/format/WKT'

import commonControls from "./controls"
import commonLayersMap from './layer';
import config from './config';

import commercialzoneLayersMap from './commercialzone/layer';
import UI from "./ui.js"
import Externals from './commercialzone/external';
import services from "./commercialzone/services";


const SESSION_EXTENT_KEY = "commercialzone_extent";


let customMapOptions = config.getCustomMapOptions();
console.log("commercialspace")
//layer zusammenstellen
var layers = [];
layers.push(commonLayersMap["baseLayers"])
layers.push(commonLayersMap["overlays"])
layers = layers.concat(commercialzoneLayersMap["layers"]);
layers.push(commonLayersMap["interactivLayerGroup"]);

console.log("window.devicePixelRatio: " + window.devicePixelRatio)

//workaround for Mask and OSM Layer, works only with dpi 1
//pixelRatio:1,

var map = new Map({
    target: 'map',
    pixelRatio: 1,
    layers: layers,
    view: new View({
        extent: transformExtent(customMapOptions.extent, "EPSG:25832",
            "EPSG:3857"),
        constrainOnlyCenter: true,
        projection: 'EPSG:3857'
    })
});
const resolution = map.getView().getResolutionForExtent(customMapOptions.extent);
const zoom = map.getView().getZoomForResolution(resolution) - 1;
map.getView().setMinZoom(zoom)


map.on("change:size", () => {
    setTimeout(() => {
        const resolution = map.getView().getResolutionForExtent(customMapOptions.extent);
        const zoom = map.getView().getZoomForResolution(resolution) - 1;
        map.getView().setMinZoom(zoom)
    }, 1000);

});


// vorherigen extent wieder herstellen, falls vorhanden
var sessionExtent = sessionStorage.getItem(SESSION_EXTENT_KEY);
if (sessionExtent) {
    try {
        map.getView().fit(sessionExtent.split(","), { nearest: true })
    } catch (e) {
        console.error(e)

        map.getView().fit(transformExtent(customMapOptions.extent, "EPSG:25832", "EPSG:3857"))
        sessionStorage.setItem(SESSION_EXTENT_KEY, map.getView().calculateExtent(map.getSize()));
    }
} else {
    map.getView().fit(
        transformExtent(customMapOptions.extent, "EPSG:25832",
            "EPSG:3857"), { nearest: true })
}
map.on("moveend", function () {
    // Daten im sessionStorage speichern
    sessionStorage.setItem(SESSION_EXTENT_KEY, map.getView().calculateExtent(map.getSize()));

    let resolution = map.getView().getResolutionForExtent(transformExtent(customMapOptions.extent, "EPSG:25832", "EPSG:3857"))
    let zoom = map.getView().getZoomForResolution(resolution);
    map.getView().setMinZoom(zoom);

})



var maskFeature = new WKT().readFeature(customMapOptions.mask, {
    dataProjection: "EPSG:25832",
    featureProjection: "EPSG:3857"
});
var bb = new Mask({ feature: maskFeature, inner: false, fill: new Fill({ color: [238, 238, 238, 0.7] }) });

commonLayersMap["baseLayers"].getLayers().forEach((layer) => {
    console.log(layer.get("name"));
    layer.addFilter(bb);

});

commonControls.forEach(c => map.addControl(c));





map.on('click', function (event) {
    $(".mappopup").hide();
    var coord = transform(event.coordinate, "EPSG:3857", "EPSG:25832")
    services.fetchInfo(coord[0], coord[1])
});


var ui = new UI(map);
ui.initializeUI();

ui.addAutocomplete({
    selector: '#commercialZoneName',
    restpath: "commercialspace/suggest/commzonename",
    transformResult: (json) => {
        return json.map(entry => {
            var suggestEntry = {
                text: entry,
                value: entry,
                id: entry
            }
            return suggestEntry;
        })
    },
    formatResult: (item) => {
        return item;
    },
    beforeSearch: (query) => {
        var formElements = $("form").serializeArray();
        var query = "";
        formElements.forEach(function (elem) {

            if (elem.name.startsWith("j_id") || elem.name === "currentPage" || elem.name === "city_select" || elem.name === "javax.faces.ViewState") {
                return;
            }

            query += "&" + elem.name + "=" + (elem.value === "on" ? true : elem.value);
        })
        return "?suggest" + query;
    }
});

ui.initAutocompleteOptions();
var externals = new Externals(map, ui);

externals.replaceMap();
setTimeout(function () { map.updateSize() }, 20);





$(window).resize(function () {
    setTimeout(function () { externals.replaceMap() }, 50);

});



window.doDeselectAndHidePopup = externals.doDeselectAndHidePopup.bind(externals);
window.updateOpacity = externals.updateOpacity.bind(externals);
window.replaceMap = externals.replaceMap.bind(externals);

window.onPageEvent = externals.onPageEvent.bind(externals);

window.onResetEvent = externals.onResetEvent.bind(externals);

window.onSearchEvent = externals.onSearchEvent.bind(externals);

window.zoomTo = externals.zoomTo.bind(externals);

window.doDeselect = externals.doDeselect.bind(externals);

window.doHighlite = externals.doHighlite.bind(externals);

window.doSearch = externals.doSearch.bind(externals);

window.fetchInfoByID = services.fetchInfoByID.bind(services);

